<template>
  <div>
    <div id="stripe-elements" class="sentry-mask"></div>
  </div>
</template>

<script>
import { initStripe } from '../../api/stripe';

export default {
  name: 'StripeElements',
  components: {},
  props: {
    publicKey: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: false,
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: function(value) {
        return ['payment', 'setup'].includes(value);
      }
    },
    billingDetails: {
      type: Object,
      required: false,
      default: null,
    },
    renderFormOnMount: {
      type: Boolean,
      required: false,
      default: true,
    },
    wallets: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      instance: {},
      elements: {},
    };
  },
  computed: {},
  async mounted() {
    this.instance = await initStripe(this.publicKey, { locale: this.$i18n.locale });

    const options = {
      mode: this.mode,
      currency: this.currency.toLowerCase(),
      paymentMethodTypes: ['card'],
    };

    if (this.mode === 'payment') {
      options.amount = Math.round(this.amount * 100);
      options.paymentMethodCreation = 'manual';
    }

    this.elements = this.instance.elements(options);

    if (this.renderFormOnMount) {
      this.mountPaymentElement();
    }

    this.$emit('stripe:ready');
  },
  methods: {
    async confirmSetup(paymentOptions) {
      try {
        this.$emit('stripe:processing');
        await this.triggerValidationAndSubmit();

        paymentOptions.elements = this.elements;
        this.instance
          .confirmSetup(paymentOptions)
          .then(confirmSetup => {
            const { error } = confirmSetup;

            if (error) {
              throw error;
            }

            // Stripe's SDK will redirect in most cases, this event probably won't be triggered.
            this.$emit('stripe:setup-confirmed', confirmSetup);
          })
          .catch(error => {
            this.$emit('stripe:failed', error);
          });
      } catch (error) {
        this.$emit('stripe:failed', error);
      }
    },
    async createPaymentMethod(paymentOptions) {
      try {
        this.$emit('stripe:processing');
        await this.triggerValidationAndSubmit();

        paymentOptions.elements = this.elements;
        return this.instance.createPaymentMethod(paymentOptions);
      } catch (error) {
        this.$emit('stripe:failed', error);
      }
    },
    async triggerValidationAndSubmit() {
      // Trigger form validation and wallet collection
      const { error: submitError } = await this.elements.submit();
      if (submitError) {
        throw submitError;
      }
    },
    async getSetupIntent(clientSecret) {
      this.$emit('stripe:processing');

      const { setupIntent } = await this.instance.retrieveSetupIntent(clientSecret);

      if (setupIntent.status === 'succeeded') {
        this.$emit('stripe:setup-intent-created', setupIntent);
        return;
      }

      this.$emit('stripe:failed');
    },
    mountPaymentElement() {
      const paymentElementOptions = {
        defaultValues: {
          billingDetails: this.billingDetails,
        },
      };

      if (this.wallets) {
        paymentElementOptions.wallets = this.wallets;
      }

      const paymentElement = this.elements.create('payment', paymentElementOptions);
      paymentElement.mount('#stripe-elements');
      paymentElement.on('change', event => {
        if (event.complete) {
          this.$emit('stripe:complete', event);
        }
      });
    },
  },
};
</script>
